import Vue from 'vue';
export default Vue.extend({
    props: {
        image: {
            type: Object,
            required: true,
        },
        pictureClass: {
            type: String,
            default: null,
        },
        draggable: {
            type: Boolean,
            default: true,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
        alt: {
            type: String,
            default: null,
            required: false,
        },
        watermark: {
            type: Boolean,
            default: false,
        },
        // Image width for breakpoints
        hd: {
            type: String,
            default: '2560x0_ratio'
        },
        xxl: {
            type: String,
            default: '1920x0_ratio'
        },
        xl: {
            type: String,
            default: '1440x0_ratio'
        },
        lg: {
            type: String,
            default: '1200x0_ratio'
        },
        md: {
            type: String,
            default: '992x0_ratio'
        },
        sm: {
            type: String,
            default: '768x0_ratio'
        },
        xs: {
            type: String,
            default: '576x0_ratio'
        }
    }
});
